import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IValidateVoucherResponse, IVoucherData, IVoucherMarkForPaymentRequest, IWidgetsReqAndRes } from "../../Orchestrator/Types/Interface/IVoucher";
import { IVoucherDetail } from "../../Orchestrator/Types/Interface/IVoucherDetail";


export async function validateVoucherByVoucherCode(bookingId: string, voucherCode: string): Promise<IApiResponse<IValidateVoucherResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.validateVoucherAPI(bookingId, voucherCode);
    return await apiRequest<IValidateVoucherResponse>(endpoint, 'POST', {
        body: JSON.stringify({ offerPartIds: [] })
    });
}

export async function markForVoucherPayment(bookingId: string, voucherCode: string, payload: IVoucherMarkForPaymentRequest): Promise<IApiResponse<IWidgetsReqAndRes>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.markForVoucherPaymentAPI(bookingId, voucherCode);

    return await apiRequest<IWidgetsReqAndRes>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}

export async function removeVoucher(bookingId: string, voucherCode: string): Promise<IApiResponse<IWidgetsReqAndRes>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.markForVoucherPaymentAPI(bookingId, voucherCode);

    return await apiRequest<IWidgetsReqAndRes>(endpoint, 'DELETE', {
        body: JSON.stringify({ offerPartIds: [] })
    });
}

export async function payWithVoucher(bookingId: string, payload: any): Promise<IApiResponse<IWidgetsReqAndRes>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.payWithVoucherAPI(bookingId);

    return await apiRequest<IWidgetsReqAndRes>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}


export async function fetchVouchers(userId: number): Promise<IApiResponse<IVoucherData[]>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.fetchVouchersAPI(userId);

    return await apiRequest<IVoucherData[]>(endpoint, 'GET');
}

export async function fetchVoucherDetails(userId: number, voucherId: number): Promise<IApiResponse<IVoucherDetail>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.fetchVoucherDetailsAPI(userId, voucherId);

    return await apiRequest<IVoucherDetail>(endpoint, 'GET');
}

export async function addVoucher(userId: number, voucherCode: string): Promise<IApiResponse<IVoucherData>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.addVoucherAPI(userId);
    // No global toast or loader: the add-voucher form shows its own spinner and
    // message (toAddVoucherErrorKey).
    return await apiRequest<IVoucherData>(endpoint, 'POST',
        {
            body: JSON.stringify({ "voucherCode": voucherCode })
        },
        "none", undefined, undefined, false, false
    );
}   
